import { LISTA_PERMISSOES } from '../util/listaPermissoes'

export const rotasFinanceiro = [
    {
        path: "/fin/minhaempresa",
        name: 'MinhaEmpresa',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/minhaempresa/minhaEmpresaEditar.vue')
    },
    {
        path: "/fin",
        name: 'finDashBoard',
        exact: true,
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/dashBoard.vue')
    },
    {
        path: '/fin/contaspagar',
        name: 'ContasPagar',
        exact: true,
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contaspagar/contasPagarListagem')
    },
    {
        path: "/fin/contasreceber",
        name: 'ContasReceber',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contasreceber/contasReceberListagem')
    },
    {
        path: "/fin/contasreceber/:id",
        name: 'ContasReceberEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contasreceber/contasReceberEditar')
    },
    {
        path: "/fin/estoque/posicao",
        name: 'PosicaoEstoqueFin',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/posicaoEstoqueListagem')
    },
    {
        path: "/fin/precificacaoprodutos",
        name: 'PrecificacaoProdutos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/precificacaoProdutos')
    },
    {
        path: "/fin/produtos",
        name: 'Produtos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/produtos/produtosListagem')
    },
    {
        path: "/fin/produtos/:id",
        name: 'ProdutosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/produtos/produtosEditar')
    },
    {
        path: "/fin/equipamentocliente",
        name: 'EquipamentoCliente',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/equipamentocliente/equipamentoclienteListagem')
    },
    {
        path: "/fin/equipamentocliente/:id",
        name: 'EquipamentoClienteEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/equipamentocliente/equipamentoclienteEditar')
    },
    {
        path: "/fin/servicos",
        name: 'Servicos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/servicos/servicosListagem')
    },
    {
        path: "/fin/servicos/:id",
        name: 'ServicosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/servicos/servicosEditar')
    },
    {
        path: "/fin/vendas",
        name: 'Vendas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/vendas/vendasListagem')
    },
    {
        path: "/fin/vendas/:id",
        name: 'VendasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/vendas/vendasEditar')
    },
    {
        path: "/fin/vendas/devolucao/:id",
        name: 'VendasDevolucao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/vendas/vendasDevolucao')
    },
    {
        path: "/fin/colaboradores",
        name: 'Colaboradores',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/colaboradores/colaboradoresListagem')
    },
    {
        path: "/fin/colaboradores/:id",
        name: 'ColaboradoresEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/colaboradores/colaboradoresEditar')
    },
    {
        path: "/fin/ordemservico",
        name: 'OrdemServico',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/ordemservico/ordemservicoListagem.vue')
    },
    {
        // Quadro kanban de OS — declarada antes de "/fin/ordemservico/:id".
        path: "/fin/ordemservico/kanban",
        name: 'OrdemServicoKanban',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/ordemservico/ordemservicoKanban.vue')
    },
    {
        // Tela de MODELO/rascunho visual — sem funcionalidade ainda, ver
        // src/views/fin/ordemservico/ordemservicoEditar.vue e [[project_ordemservico_nfse_module]]
        path: "/fin/ordemservico/:id",
        name: 'OrdemServicoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/ordemservico/ordemservicoEditar.vue')
    },
    {
        path: "/fin/titulofinanceirocategoria",
        name: 'Titulofinanceirocategoria',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/titulofinanceirocategoria/titulofinanceirocategoriaListagem.vue')
    },
    {
        path: "/fin/titulofinanceirocategoria/:id",
        name: 'TitulofinanceirocategoriaEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/titulofinanceirocategoria/titulofinanceirocategoriaEditar.vue')
    },
    {
        path: "/fin/contafinanceira",
        name: 'Contafinanceira',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contafinanceira/contafinanceiraListagem.vue')
    },
    {
        path: "/fin/contafinanceira/:id",
        name: 'ContafinanceiraEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contafinanceira/contafinanceiraEditar.vue')
    },
    {
        path: "/fin/boletoconfiguracao",
        name: 'Boletoconfiguracao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/boletoconfiguracao/boletoconfiguracaoListagem.vue')
    },
    {
        path: "/fin/boletoconfiguracao/:id",
        name: 'BoletoconfiguracaoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/boletoconfiguracao/boletoconfiguracaoEditar.vue')
    },
    {
        path: "/fin/boleto",
        name: 'Boleto',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/boleto/boletoListagem.vue')
    },
    {
        path: "/fin/boleto/:id",
        name: 'BoletoVisualizar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/boleto/boletoVisualizar.vue')
    },
    {
        path: "/fin/boletoremessa",
        name: 'Boletoremessa',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/boleto/boletoremessaListagem.vue')
    },
    {
        path: "/fin/formapagamentocontafinanceira",
        name: 'Formapagamentocontafinanceira',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/formapagamentocontafinanceira/formapagamentocontafinanceiraEditar.vue')
    },
    {
        path: "/fin/fluxocaixa",
        name: 'FluxoCaixa',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/fluxocaixa/fluxoCaixa.vue')
    },
    {
        path: "/fin/transferenciacontafinanceira",
        name: 'Transferenciacontafinanceira',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/transferenciacontafinanceira/transferenciacontafinanceiraListagem.vue')
    },
    {
        path: "/fin/transferenciacontafinanceira/:id",
        name: 'TransferenciacontafinanceiraEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/transferenciacontafinanceira/transferenciacontafinanceiraEditar.vue')
    },
    {
        path: "/fin/importarfatura",
        name: 'ImportarFatura',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/importacaofatura/importarFatura.vue')
    },
    {
        path: "/fin/nfse/:id",
        name: 'NfseEmitir',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfse/nfseEmitir.vue')
    },
    {
        path: "/fin/nfse",
        name: 'Nfse',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfse/nfseListagem.vue')
    },
    {
        path: "/fin/nfse/visualizar/:id",
        name: 'NfseVisualizar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfse/nfseVisualizar.vue')
    },
    {
        path: "/fin/nfe",
        name: 'Nfe',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfe/nfeListagem')
    },
    {
        path: "/fin/nfe/:id",
        name: 'NfeEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfe/nfeEditar')
    },
    {
        path: "/fin/nfe/avulsa",
        name: 'NfeEmitirAvulsa',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfe/nfeEmitirAvulsa')
    },
    {
        path: "/fin/unidadesmedida",
        name: 'UnidadesMedida',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/unidademedida/unidadeMedidaListagem')
    },
    {
        path: "/fin/unidadesmedida/:id",
        name: 'UnidadesMedidaEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/unidademedida/unidadeMedidaEditar')
    },
    {
        path: "/fin/contaspagarfixas",
        name: 'ContasPagarFixas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contaspagarfixa/contasPagarFixaListagem')
    },
    {
        path: "/fin/contaspagar/:id",
        name: 'ContasPagarEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contaspagar/contasPagarEditar')
    },
    {
        path: "/fin/contaspagarfixa/:id",
        name: 'ContasPagarFixaEditar',
        meta: {
            abrirDentroDoLayout: true,
            menu: '/fin/contaspagarfixas', // menu destacado (a URL não fica sob a da listagem)
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/contaspagarfixa/contasPagarFixaEditar')
    },
    {
        path: "/fin/catalogos",
        name: 'Catalogos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/catalogo/CatalogoListagem')
    },
    {
        path: "/fin/catalogo/:id",
        name: 'CatalogoEditar',
        meta: {
            abrirDentroDoLayout: true,
            menu: '/fin/catalogos', // menu destacado (a URL não fica sob a da listagem)
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/catalogo/CatalogoEditar')
    },
    {
        path: "/fin/pessoas",
        name: 'CadPessoas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/pessoas/pessoasListagem')
    },
    {
        path: "/fin/caracteristicas",
        name: 'Caracteristicas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/caracteristicas/CaracteristicasListagem')
    },
    {
        path: "/fin/caracteristicas/:id",
        name: 'CaracteristicasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/caracteristicas/CaracteristicasEditar')
    },
    {
        path: "/fin/municipios",
        name: 'Municipios',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/municipios/municipiosListagem')
    },
    {
        path: "/fin/bairros",
        name: 'Bairros',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/bairros/bairrosListagem')
    },
    {
        path: "/fin/municipios/:id",
        name: 'MunicipiosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/municipios/municipiosEditar')
    },
    {
        path: "/fin/bairros/:id",
        name: 'BairrosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/bairros/bairrosEditar')
    },
    {
        path: "/fin/parametros",
        name: 'Parametros',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/parametrosSistema')
    },

    {
        path: "/fin/pessoas/:id",
        name: 'PessoasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/pessoas/pessoasEditar')
    },
    {
        path: "/fin/relvendaporprodutos",
        name: 'RelVendaPorProdutos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/relatorios/relVendaPorProduto')
    },
    {
        path: "/fin/relvendascomnfe",
        name: 'RelVendasComNfe',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/relatorios/relVendasComNfe')
    },
    {
        // Depósito é gen.Deposito, compartilhado com a saúde (mesma tela de
        // /sde/deposito) — registrado aqui de novo porque o router troca todo o
        // conjunto de rotas por sistema (ver routesManager.js), então o item de
        // menu só aparece se a rota existir também no conjunto do Financeiro.
        path: "/sde/deposito",
        name: 'depositoFinanceiro',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/sde/deposito/depositoListagem')
    },
    {
        path: "/sde/deposito/:id",
        name: 'depositoFinanceiroEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/sde/deposito/depositoEditar')
    },
    {
        path: '/fin/fornecedores',
        name: 'Fornecedores',
        exact: true,
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/fornecedor/FornecedorListagem')
    },
    {
        path: "/fin/fornecedores/:id",
        name: 'FornecedoresEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/fornecedor/FornecedorEditar')
    },
    {
        path: '/fin/nfeentrada',
        name: 'NfeEntrada',
        exact: true,
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfeentrada/NfeentradaListagem')
    },
    {
        path: "/fin/nfeentrada/:id",
        name: 'NfeEntradaEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfeentrada/NfeentradaEditar')
    },
    {
        path: "/fin/nfeentrada/devolucao/:id",
        name: 'NfeEntradaDevolucao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfeentradadevolucao/NfeentradaDevolucao')
    },
    {
        path: "/fin/nfeentradadevolucao",
        name: 'NfeEntradaDevolucaoListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfeentradadevolucao/NfeentradaDevolucaoListagem')
    },
    {
        path: "/fin/cnae",
        name: 'Cnae',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/cnae/cnaeListagem.vue')
    },
    {
        path: "/fin/cnae/:id",
        name: 'CnaeEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/gen/cnae/cnaeEditar.vue')
    },
    {
        path: "/fin/nfseitemlistaservico",
        name: 'NfseItemListaServico',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfseitemlistaservico/nfseitemlistaservicoListagem.vue')
    },
    {
        path: "/fin/nfseitemlistaservico/:id",
        name: 'NfseItemListaServicoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfseitemlistaservico/nfseitemlistaservicoEditar.vue')
    },
    {
        path: "/fin/nfsenbs",
        name: 'NfseNbs',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfsenbs/nfsenbsListagem.vue')
    },
    {
        path: "/fin/nfsenbs/:id",
        name: 'NfseNbsEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfsenbs/nfsenbsEditar.vue')
    },
    {
        path: "/fin/nfsecnaeitemlistaservico",
        name: 'NfseCnaeItemListaServico',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfsecnaeitemlistaservico/nfsecnaeitemlistaservicoListagem.vue')
    },
    {
        path: "/fin/nfsecnaeitemlistaservico/:id",
        name: 'NfseCnaeItemListaServicoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfsecnaeitemlistaservico/nfsecnaeitemlistaservicoEditar.vue')
    },
    {
        path: "/fin/nfsecorrelacaonacional",
        name: 'NfseCorrelacaoNacional',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfsecorrelacaonacional/nfsecorrelacaonacionalListagem.vue')
    },
    {
        path: "/fin/nfsecorrelacaonacional/:id",
        name: 'NfseCorrelacaoNacionalEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfsecorrelacaonacional/nfsecorrelacaonacionalEditar.vue')
    },
    {
        path: "/fin/nfseindicadoroperacao",
        name: 'NfseIndicadorOperacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfseindicadoroperacao/nfseindicadoroperacaoListagem.vue')
    },
    {
        path: "/fin/nfseindicadoroperacao/:id",
        name: 'NfseIndicadorOperacaoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfseindicadoroperacao/nfseindicadoroperacaoEditar.vue')
    },
    {
        path: "/fin/nfseclassificacaotributaria",
        name: 'NfseClassificacaoTributaria',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfseclassificacaotributaria/nfseclassificacaotributariaListagem.vue')
    },
    {
        path: "/fin/nfseclassificacaotributaria/:id",
        name: 'NfseClassificacaoTributariaEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/fin/nfseclassificacaotributaria/nfseclassificacaotributariaEditar.vue')
    },
    {
        path: "/fin/nfseconfiguracao",
        name: 'NfseConfiguracao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfseconfiguracao/nfseconfiguracaoListagem.vue')
    },
    {
        path: "/fin/nfseconfiguracao/:id",
        name: 'NfseConfiguracaoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfseconfiguracao/nfseconfiguracaoEditar.vue')
    },
    {
        path: "/fin/nfeconfiguracao",
        name: 'NfeConfiguracao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfe/nfeconfiguracaoListagem.vue')
    },
    {
        path: "/fin/nfeconfiguracao/:id",
        name: 'NfeConfiguracaoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/nfe/nfeconfiguracaoEditar.vue')
    },
    {
        path: "/fin/mapagarantias",
        name: 'MapaGarantias',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.FIN_ADMIN, LISTA_PERMISSOES.FIN_USUARIO],
        },
        component: () => import('@/views/fin/mapagarantias/mapaGarantias.vue')
    },
]